<script setup lang="ts">
// "Which one do you mean?" (v3 `OrpheusAmbiguousQuery.vue`, ORP-19803 restyle): the answer's
// question, then one chip per reading. The chip row matches the follow-up chips — same pill, same
// orange hover — so a clarification reads as part of the answer, not a form.
import type { Clarification, ClarificationOption } from '../models/orpheusClarification.types'

import { useI18n } from '@/shared/i18n'

withDefaults(defineProps<{ clarification: Clarification; loading?: boolean }>(), {
  loading: false,
})
const emit = defineEmits<{ select: [option: ClarificationOption] }>()
const { t } = useI18n()
</script>

<template>
  <div class="orpheus-clarification w-full" data-testid="orpheus-clarification">
    <p class="m-0 w-full whitespace-normal wrap-anywhere text-sm leading-relaxed text-fg">
      {{ clarification.title || t('orpheus.clarification.defaultTitle') }}
    </p>
    <p v-if="clarification.description" class="mt-2 mb-0 text-sm leading-relaxed text-muted">
      {{ clarification.description }}
    </p>

    <div class="mt-4 flex flex-wrap gap-2">
      <button
        v-for="option in clarification.options"
        :key="String(option.id ?? `${option.message}-${option.label}`)"
        type="button"
        :disabled="loading"
        :title="option.description || undefined"
        class="cursor-pointer rounded-full border border-border bg-surface px-3.5 py-2 text-sm font-medium text-fg shadow-sm transition hover:border-orpheus-brand/50 hover:text-orpheus-brand hover:shadow-orpheus-composer disabled:cursor-not-allowed disabled:opacity-60"
        data-testid="orpheus-clarification-option"
        @click="emit('select', option)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
